import func from "@uikit/func";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { disablePublishDisplayType } from "../Nodes/nodeConfig";
import { GROUPID_REG } from "@views/thinking-layout-editor/constants";
import { useCallback } from "react";
import { HomeMethodsUtil } from "@uikit/util/_homeUtil";
import { PreviewService } from "imagica-corekit/dist/cases/preview/PreviewService";
import { getIt } from "@uikit/getIt";
import { logEvent } from "@uikit/service/amplitude";
import { useDispatch } from "react-redux";
import { fotActions } from "@store/fot";
import { projectPageStore } from "./store/ProjectPageStore";
import { creatorRefStore } from "./store/CreatorRefStore";
import { previewStore } from "@uiview/store/PreviewStore";
import { ViewBuilderData, ViewBuilderWorker } from "imagica-uikit/dist/nodesV2/ViewBuilderComponents/ViewBuilderWorker";
import { CreatorSaasAppStore } from "./store/CreatorSaasAppStore";
import { PreviewContentUtil } from "../PreviewApp/PreviewContentUtil";
import { HomePluginStore } from "imagica-corekit/dist/base/store/HomePluginStore";
import { CreatorNodesStore } from "./store/CreatorNodesStore";
import { PreviewAppStore } from "./store/PreviewAppStore";
import { ProjectNodeStore } from "@uikit/projectNode/ProjectNodeStore";

// eslint-disable-next-line
export function useHomePreviewMethods() {
  const previewService = getIt(PreviewService);
  const creatorSaasAppStore = getIt(CreatorSaasAppStore);
  const homePluginStore = getIt(HomePluginStore);
  const creatorNodesStore = getIt(CreatorNodesStore);
  const isShare = homePluginStore.state.isShare;
  const previewAppStore = getIt(PreviewAppStore);
  const projectNodeStore = getIt(ProjectNodeStore);

  const { addPreview, getPreviewAppActiveLable } = usePreviewAppStore();

  const dispatch = useDispatch();
  const setDisableAddPreview = useCallback(
    (val: boolean) => {
      dispatch(fotActions.setDisableAddPreview(val));
    },
    [dispatch]
  );

  const addSingleNodeToPreview = useCallback((node: any, previewUI: any, isCotAddToPreview: boolean) => {
    if (func.isEmpty(node)) return;
    if (func.isEmpty(node.data.textAreaValue) && isCotAddToPreview === false) {
      func.customMsg({
        content: "The node is empty",
        type: "info",
      });
      return;
    }
    const list = PreviewContentUtil.getPreviewOutputBySingleNode({
      saasUIData: creatorSaasAppStore.state.saasUIData as any,
      output: creatorSaasAppStore.state.saasUIData.output,
      addContentId: previewStore.state.addContentId,
      node,
      isShare,
    });
    // stud-1832 chat ai input
    creatorSaasAppStore.setSaasUIData(prevData => {
      return {
        ...prevData,
        output: list,
      };
    });
    return list;
  }, []);

  // 添加单个到 preview
  const addIndividual = useCallback(
    (node: any, previewUI = previewStore.state.selectedUI, isCotAddToPreview = false) => {
      if (previewUI === "") {
        previewAppStore.setShowPreviewPanel(true);
        projectPageStore.state.awaitAddNode = node;
        return;
      }
      // OPT:
      if (disablePublishDisplayType.includes(node?.data?.displayType)) {
        return;
      }
      // bsf-4915 single 外部去掉了 parentNode, 未来可将下一行去掉， getPreviewOutputBySingleNode 内部实现了优先级
      const obj = Object.assign({}, { ...node }, { parentNode: "" });
      const list = addSingleNodeToPreview(obj, previewUI, isCotAddToPreview) as any[];
      if (func.isEmpty(list)) return;
      // bsf-4912 use setSassUIData
      creatorSaasAppStore.setSaasUIData(prev => ({ ...prev, output: list }));
      if (isCotAddToPreview === false) {
        previewAppStore.setShowPreviewPanel(true);
      }
      creatorRefStore.nodeContextMenuRef.current = null;
    },
    [addSingleNodeToPreview]
  );

  const addGroupNodeToPreview = useCallback((groupChildeNodes: any, previewUI: string, getResult?: any) => {
    const list = PreviewContentUtil.getPreviewOutputByGroupNode({
      output: creatorSaasAppStore.state.saasUIData.output,
      groupChildeNodes,
      getResult,
      addContentId: previewStore.state.addContentId,
      isShare,
    });
    creatorSaasAppStore.setSaasUIData(prevData => {
      return {
        ...prevData,
        output: list,
      };
    });
    return list;
  }, []);

  // 添加group到 preview
  const clickGroupToPreview = useCallback(
    (node: any, previewUI = previewStore.state.selectedUI, isCotAddToPreview = false) => {
      if (!GROUPID_REG.test(node.id)) return;
      if (previewUI === "") {
        previewAppStore.setShowPreviewPanel(true);
        projectPageStore.state.awaitAddNode = node;
        return;
      }
      const groupChildeNodes = creatorNodesStore.getNodes().filter(x => x.parentNode === node.id);

      // group
      const list = addGroupNodeToPreview(groupChildeNodes, previewUI);
      // bsf-4912 use setSassUIData
      creatorSaasAppStore.setSaasUIData(prev => ({ ...prev, output: list }));
      if (isCotAddToPreview === false) {
        previewAppStore.setShowPreviewPanel(true);
      }
      creatorRefStore.nodeContextMenuRef.current = null;
    },
    [addGroupNodeToPreview]
  );

  // 重置右侧preview数据
  const resetPreviewData = useCallback(() => {
    previewAppStore.resetPreviewData();
  }, []);

  const addToPreviewList = useCallback(
    (format: any) => {
      // 传入进来的 preview panel 选择项
      if (format) {
        format && addPreview({ format });
      }
    },
    [addPreview]
  );
  const updatePreviewNodeContent = useCallback((param: any) => {
    const { nodeId, textAreaValue, displayType, errorText, data = {} } = param;
    // bsf-4912 replace thoughts
    const tempThoughts = [...creatorSaasAppStore.state.saasUIData.output];

    // 处理 viewbuilderdata
    const showBuilderUI = ViewBuilderWorker.isShowBuilderUI(data?.showBuilderUI ?? false);
    let viewBuilderData = new ViewBuilderData();
    if (displayType === "text" && showBuilderUI) {
      viewBuilderData = data?.viewBuilderData || new ViewBuilderData();
    }

    const { content, contentType } = PreviewContentUtil.getPreviewContentByNode(param);
    // 更新ui数据
    const newSaasArr = HomeMethodsUtil.generateNewData(
      creatorSaasAppStore.state.saasUIData.output,
      nodeId,
      content,
      contentType,
      errorText,
      viewBuilderData
    ) as any[];
    // 更新SaasUIData
    const newSaasInput = HomeMethodsUtil.getNewInputData(
      creatorSaasAppStore.state.saasUIData.input,
      nodeId,
      textAreaValue,
      homePluginStore.state.isShare
    ) as any[];

    // stud-2493 set input(preview)
    creatorSaasAppStore.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newSaasInput,
        output: newSaasArr,
      };
    });
    projectNodeStore.composeNodes(creatorNodesStore.getNodes(), creatorSaasAppStore.state.saasUIData);

    //
    // 更新显示数据
    const newArr = HomeMethodsUtil.generateNewData(
      tempThoughts,
      nodeId,
      content,
      contentType,
      errorText,
      viewBuilderData
    );
    // bsf-4912 use setSassUIData
    creatorSaasAppStore.setSaasUIData(prev => ({ ...prev, output: newArr as any[] }));
  }, []);

  const genLink = useCallback(
    async (index: any, uuid: any) => {
      const link = await previewService.getLink({
        index,
        structureLinkParams: {
          appId: previewStore.state.previewAppAcivieId as any,
          enablePreviewApp: true,
          selectedUI: previewStore.state.selectedUI,
          // opt:
          stripe_price_id: previewAppStore.getSelectedTemplate()?.published_metadata?.stripe_price_id,
          type: getPreviewAppActiveLable(),
          uuid,
          legacy_project_attr_indexer: previewAppStore.getSelectedTemplate()?.legacy_project_attr_indexer,
        },
      });
      navigator.clipboard.writeText(link);
      return link;
    },
    [getPreviewAppActiveLable]
  );

  const cancelCreatePreview = useCallback(() => {
    projectPageStore.state.awaitAddNode = undefined;
  }, []);

  // 关闭preview
  const closePreviewApp = useCallback(() => {
    logEvent("close_publish_x");
    previewAppStore.setShowPreviewPanel(false);
    setDisableAddPreview(true);
    cancelCreatePreview();
    previewAppStore.saasUiDataToPreview();
    // FIXME: 清空当前激活的 app, 判断是否时 chat app 时会根据当前的 saasuidata 判断, saasuidata 没有清空则数据没有发生变化 canvas addto 按钮状态会出现错误
    previewAppStore.clearCurrentPreviewApp();
  }, [cancelCreatePreview, setDisableAddPreview]);

  const awaitAddNodeFunc = useCallback(() => {
    if (projectPageStore.state.awaitAddNode) {
      setTimeout(() => {
        projectPageStore.state.awaitAddNode?.type === "customGroup"
          ? clickGroupToPreview(projectPageStore.state.awaitAddNode)
          : addIndividual(projectPageStore.state.awaitAddNode);
        projectPageStore.state.awaitAddNode = undefined;
      }, 1000);
    }
  }, [addIndividual, clickGroupToPreview]);

  // 添加多个到 preview
  const clickToPreviewNode = useCallback(
    (node: any, previewUI = previewStore.state.selectedUI) => {
      let list = [] as any[];
      // opt:
      // const groupChildeNodes = isGroupChildeNodes(node);
      const groupChildeNodes = HomeMethodsUtil.isGroupChildeNodes(node, creatorNodesStore.getNodes());
      if (!func.isEmpty(groupChildeNodes)) {
        // group
        list = addGroupNodeToPreview(groupChildeNodes, previewUI);
      }
      // bsf-4912 use setSassUIData
      creatorSaasAppStore.setSaasUIData(prev => ({ ...prev, output: list }));
      previewAppStore.setShowPreviewPanel(true);
      creatorRefStore.nodeContextMenuRef.current = null;
    },
    [addGroupNodeToPreview]
  );

  return {
    addSingleNodeToPreview,
    addIndividual,
    addGroupNodeToPreview,
    clickGroupToPreview,
    /**
     * @deprecated use `previewAppStore.resetPreviewData`
     */
    resetPreviewData,
    addToPreviewList,
    updatePreviewNodeContent,
    genLink,
    cancelCreatePreview,
    closePreviewApp,
    awaitAddNodeFunc,
    clickToPreviewNode,
  };
}
